import ArticleLayout from '@/components/feature/ArticleLayout';
import { cssbuyArticleContent } from '@/mocks/seoContent';

export default function CssbuyArticle() {
  return (
    <ArticleLayout
      article={cssbuyArticleContent}
      heroImage="https://readdy.ai/api/search-image?query=Professional%20dual%20monitor%20workstation%20with%20analytics%20dashboards%20displayed%2C%20minimal%20modern%20office%20setup%2C%20warm%20ambient%20desk%20lamp%20lighting%2C%20dark%20wood%20desk%20surface%2C%20editorial%20tech%20photography%2C%20clean%20professional%20aesthetic%2C%20soft%20depth%20of%20field&width=1200&height=600&seq=article-cssbuy-hero-v3&orientation=landscape"
      heroImageAlt="CSSBuy Spreadsheet advanced product research and comparison platform"
      heroImageTitle="CSSBuy Spreadsheet 2026 Complete Guide"
      tag="Advanced Guide"
      relatedArticles={[
        { title: "Hipobuy Spreadsheet Guide", slug: "hipobuy-spreadsheet-guide" },
        { title: "Kakobuy Spreadsheet Guide", slug: "kakobuy-spreadsheet" },
        { title: "Superbuy Spreadsheet Guide", slug: "superbuy-spreadsheet" },
        { title: "Oopbuy Spreadsheet Guide", slug: "oopbuy-spreadsheet" },
      ]}
    />
  );
}